/** @jsxImportSource theme-ui */
//
// Calculates where to put a tooltip/popover for their respective triggers
//

import { zIndex } from "../commonStyles";

// eslint-disable-next-line complexity
type CalculatePositionData = {
  position?: "top" | "bottom" | "left" | "right";
  gutter?: number;
  width?: string;
  align?: "left" | "center" | "right";
  caret?: boolean;
  offset?: string;
  caretOffset?: string;
};

type CaretPosition = "none" | "top" | "bottom" | "left" | "right";

type PositionResult = {
  caret?: CaretPosition;
  positionerProps?: {
    attachPoint: string;
    targetAttachPoint: string;
    gutterTop?: number;
    gutterBottom?: number;
    gutterLeft?: number;
    gutterRight?: number;
    align: "left" | "center" | "right";
    width?: string;
    zIndex: number;
  };
};

// eslint-disable-next-line complexity
export default function Overlay({
  position,
  gutter,
  width,
  align,
  caret,
  offset,
  caretOffset,
}: CalculatePositionData): PositionResult {
  let positionerProps;
  let caretPosition: CaretPosition | undefined;

  offset = offset || "50%";
  caretOffset = caretOffset || "50%";

  if (position === "top") {
    caretPosition = caret ? "bottom" : "none";
    positionerProps = {
      attachPoint: `${caretOffset} bottom`,
      targetAttachPoint: `${offset} top`,
      gutterBottom: gutter != null ? gutter : 0.7,
      align: align || "center",
      width,
      zIndex: zIndex.overlay,
    };
  } else if (position === "bottom") {
    caretPosition = caret ? "top" : "none";
    positionerProps = {
      attachPoint: `${caretOffset} top`,
      targetAttachPoint: `${offset} bottom`,
      gutterTop: gutter != null ? gutter : 0.7,
      align: align || "center",
      width,
      zIndex: zIndex.overlay,
    };
  } else if (position === "left") {
    caretPosition = caret ? "right" : "none";
    positionerProps = {
      attachPoint: `right ${caretOffset}`,
      targetAttachPoint: `left ${offset}`,
      gutterRight: gutter != null ? gutter : 1,
      align: align || "right",
      width,
      zIndex: zIndex.overlay,
    };
  } else if (position === "right") {
    caretPosition = caret ? "left" : "none";
    positionerProps = {
      attachPoint: `left ${caretOffset}`,
      targetAttachPoint: `right ${offset}`,
      gutterLeft: gutter != null ? gutter : 1,
      align: align || "left",
      width,
      zIndex: zIndex.overlay,
    };
  }

  return { caret: caretPosition, positionerProps };
}
